import { useContext, useEffect, useState } from "react"
import { getEvidenceData } from "../../../util/getEvidenceData";
import EmailSignatureService from "../../../services/EmailSignatureService";
import { useNavigate } from "react-router-dom";
import { BatchContext } from "../../../contexts/BatchContext";
import PendingDocumentService from "../../../services/PendingDocumentService";
import { FIRST_LOAD } from "../../../constants/GeneralConstants";
import { isFormDataMissingError } from "../../../util/signatureErrorUtils";
import { ConfirmationModalSignature } from "../../Modals/ConfirmationModalSignature/ConfirmationModalSignature";
import { FormDataMissingModal } from "../../Modals/FormDataMissingModal/FormDataMissingModal";
import { ADDITIONAL_SIGNATURES_CONTEXT_KEY, AdditionalSignaturesContext } from "../../../contexts/AdditionalSignaturesContext";

export const AdditionalSignaturesFinalFlow = ({ otpCode = '', emailId, setOTPDraw, setLoadingMorePages }) => {
    const { remainingBatchDocuments, removeDocumentsFromBatch } = useContext(BatchContext);
    const [showConfirmationModalSignature, setShowConfirmationModalSignature] = useState(false);
    const [showFormDataMissingModal, setShowFormDataMissingModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const { documentData, signatureData } = useContext(AdditionalSignaturesContext);

    const { DocGUI: docGuid, SignerDTO: signerDTO } = documentData;
    const { SignerGUI: signerGuid, eMail: email } = signerDTO;

    useEffect(() => {
        setShowConfirmationModalSignature(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const sendSignature = async () => {
        setLoading(true);
        const evidenceData = await getEvidenceData();

        let signatureBody;

        if (signatureData) signatureBody = signatureData;

        const { SignatureImage, SignatureRawData } = signatureBody;

        const body = {
            SignatureImage,
            SignatureRawData,
            OTP: otpCode,
            ...evidenceData,
        };

        EmailSignatureService.sendSign(signerGuid, body)
            .then((res) => {
                setLoading(false);
                if (res) {
                    // Clear local storage after signing doc
                    localStorage.removeItem(ADDITIONAL_SIGNATURES_CONTEXT_KEY);
                    setShowConfirmationModalSignature(false);
                    sessionStorage.setItem("SIGNED_DOC", true);
                    localStorage.setItem(FIRST_LOAD, "true")

                    removeDocumentsFromBatch([docGuid]);

                    if (remainingBatchDocuments > 1) {
                        navigate('/batch-success', {
                            state: {
                                emailId,
                            }
                        })
                        return;
                    }
                    PendingDocumentService.getPendingDocumentsList(emailId)
                        .then(res => {
                            const pendingDocuments = res.data;
                            setLoading(false);
                            navigate("/signature-success", {
                                state: {
                                    pendingDocuments,
                                    emailId,
                                    email
                                }
                            });
                        })
                        .catch(err => {
                            setLoading(false);
                            navigate("/signature-success", {
                                state: {
                                    pendingDocuments: [],
                                    emailId,
                                    email
                                }
                            });
                        });
                    return;
                }
                setLoading(false);
            })
            .catch(err => {
                setLoading(false);
                if (isFormDataMissingError(err)) {
                    setShowFormDataMissingModal(true);
                    return;
                }
                console.log(err);
            });
        return;
    }
    return (
        <>
            <ConfirmationModalSignature showConfirmationModalSignature={showConfirmationModalSignature} setShowConfirmationModalSignature={setShowConfirmationModalSignature} handleSignature={sendSignature} sendingSignPetition={loading} setOTPDraw={setOTPDraw} setLoadingMorePages={setLoadingMorePages}/>
            <FormDataMissingModal open={showFormDataMissingModal} onClose={() => setShowFormDataMissingModal(false)} />
        </>
    );
}
